/*
 * @see [Documentation](https://nuxt-graphql-middleware.dulnan.net/advanced/templates#operation-hashes)
 */
export const operationHashes = {
  "acceptDisputeProposal": "wYp1JKeBC4",
  "activeChannel": "0tVV3Csc2o",
  "activeCustomer": "fTXy7TQuTA",
  "activeCustomerAddresses": "Wj6gfd81lZ",
  "activeCustomerOrders": "vtknwqpgkz",
  "activeOrder": "WQCFlfXRI1",
  "addDisputeProposal": "k9UZgRMfFy",
  "addItemToOrder": "fDPGsQfShm",
  "addPaymentToOrder": "pEQEU3PzyK",
  "adjustOrderLine": "its903QIiE",
  "applyCouponCode": "2saEVIoDDI",
  "authenticate": "ne9zGh42wS",
  "availableCountries": "8LISOIFinx",
  "collection": "37ToxMRHOj",
  "collections": "rcVO0SUKMF",
  "createAssets": "sMrKEuqbxf",
  "createComgatePayment": "IvZtK6cABS",
  "createCustomerAddress": "KguIgXVkEt",
  "createDispute": "X1SP32y9hj",
  "createProductReview": "h-jjo4Ng5D",
  "createStripePaymentIntent": "u9BrbQo9T4",
  "deleteCustomerAddress": "HFEY12k_VT",
  "detectIntent": "kweb7JKDXz",
  "dispute": "0WuDuhs7-u",
  "disputes": "3-a6_yo5db",
  "eligibleDisputeReasons": "bLX2iTgbuo",
  "eligiblePaymentMethods": "4E8cTQNClJ",
  "eligibleShippingMethods": "Vus3T3JanV",
  "facet": "RGdaQULqfN",
  "facetValue": "N3hmQ7c9Qr",
  "facets": "UlaOQ0s_Jz",
  "isEligibleToCreateDispute": "gOyxLVb6wm",
  "login": "p0_pR17n7s",
  "logout": "NP8hhM1X_E",
  "me": "mTEmVl2Kk_",
  "nextOrderStates": "npShkmQ3CH",
  "oracle": "Lpcf3IN7U0",
  "order": "c2FGLMRMpp",
  "orderByCode": "GhSDpT9ZKb",
  "page": "iUf8fbBE2F",
  "pages": "-j8HuT_FUq",
  "product": "ZLvzATvjZ_",
  "productReviews": "aGPFD0unQl",
  "productSizeChartTables": "_g9_G6I8b2",
  "products": "eSqVbcKpkg",
  "refreshCustomerVerification": "JxB8x0aepb",
  "registerCustomerAccount": "PVZkkyYgAB",
  "rejectDisputeProposal": "Dzwavna0Vo",
  "removeAllOrderLines": "eu25chmNjG",
  "removeCouponCode": "cU3I_LE6VV",
  "removeOrderLine": "9l2KDYwyOx",
  "requestPasswordReset": "pk3Kb3mlaq",
  "requestUpdateCustomerEmailAddress": "DKTvmAL7NX",
  "resetPassword": "bPdxN-QCMX",
  "reviews": "77u-4zx5Jt",
  "search": "nfWTmJnZpt",
  "searchFacetValues": "-8qeBMnBRw",
  "searchPrices": "u3dKO3ehgU",
  "searchProduct": "ZcOBzhkXwz",
  "setCustomerForOrder": "QGn7sZr9fm",
  "setIntermediatePaymentMethod": "9-VL4BVrRu",
  "setOrderBillingAddress": "lJU5XU1GGW",
  "setOrderCustomFields": "gmp58KpY3p",
  "setOrderShippingAddress": "wSUssasrVW",
  "setOrderShippingMethod": "-VqAA3_rCS",
  "subPage": "mv__N9ndi3",
  "subPages": "-n-mceYOxF",
  "transitionOrderToState": "bJl_bwR3b6",
  "updateCustomer": "FGisBvq4ET",
  "updateCustomerAddress": "J672GGPbup",
  "updateCustomerEmailAddress": "LpBwLzldBP",
  "updateCustomerPassword": "dv4lsmQV6V",
  "updateDisputeProposal": "O4boSmdqo5",
  "verifyCustomerAccount": "7XNI0fqpKS",
  "voteOnReview": "YJd9uwsEdJ"
}